import React, { Fragment } from "react";

import { lazyWithRetry } from "../../core/lazy_with_retry";
import { OfferingDetailsMultiPass } from "../template_offering_details_multipass";
import { useTheYardAnalytics } from "./theyard_analytics";
import {
  partnerConfig,
  testimonials,
  creditPackagesGeneralInfo,
} from "./theyard_partner_config";

const Theme = lazyWithRetry(() => import("./theyard_theme"));

const faqs = [
  {
    question: "What can I use credits for?",
    answer:
      "Credits can be used to book conference rooms and private offices " +
      "during business hour at any of The Yard locations.",
  },

  {
    question: "Is there an expiration date?",
    answer: "Credits can be used for up to 12 months after you purchase them.",
  },

  {
    question: "How many credits do conference room reservations cost?",
    answer:
      "Reservations start at 2 credits for conference rooms, " +
      "4 credits for a 1 person office, and up to 18 credits for 6 person offices.",
  },

  {
    question: "Where can I use my credits?",
    answer: "Credits can be applied at any Yard location.",
  },

  {
    question: "Why do I need to select a location?",
    answer:
      "The location you select is your home location - this is the location " +
      "you will use most frequently book at but does not limit you from booking at other locations.",
  },
];

export function OfferingTheYardCreditPackages() {
  useTheYardAnalytics();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsMultiPass
        showAddress={false}
        showDirections
        partnerConfig={partnerConfig}
        data={{
          faqs,
          testimonials: testimonials,
          generalInfo: creditPackagesGeneralInfo,
        }}
      />
    </Fragment>
  );
}
